import styled from 'styled-components';

const ParagraphThreadListEmpty = styled.p``;

export default ParagraphThreadListEmpty;
